export const LOAD_DATA = 'LOAD_DATA';
export const FUEL_PRICES = 'FUEL_PRICES';
export const MILEAGE_VALID = 'MILEAGE_VALID';
export const ELECTRIC_VALID = 'ELECTRIC_VALID';
export const PETROL_VALID = 'PETROL_VALID';
export const DIESEL_VALID = 'DIESEL_VALID';